import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=924719ec&scoped=true&"
import script from "./ChangeLanguage.vue?vue&type=script&lang=ts&"
export * from "./ChangeLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=924719ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924719ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
